<template>
  <usage-bar :usage="usage">
    <span class="usage-text">{{ usageLine }}</span>
  </usage-bar>
</template>

<script>
import UsageBar from "@/components/admin/bars/UsageBar.vue";

import { roundTo } from "@/utils/calc.js";

// @group Admin Page
// Show used memory
export default {
  name: "MemoryUsageBar",
  components: {
    UsageBar
  },
  props: {
    // Full available memory in Gb
    fullMemory: {
      type: Number,
      default: 0
    },
    // Used memory in Gb
    usedMemory: {
      type: Number,
      default: 0
    },
    // Number of decimal places
    accuracy: {
      type: Number,
      default: 1,
      validator: val => {
        return Number.isInteger(val) && val >= 0;
      }
    }
  },
  computed: {
    // @vuese
    // Usage text in format {used}/{full} Gb
    usageLine() {
      const roundedMem = roundTo(this.fullMemory, this.accuracy);
      const roundedUsage = roundTo(this.usedMemory, this.accuracy);
      return `${roundedUsage}/${roundedMem} Gb`;
    },
    // @vuese
    // Usage part in range [0:1]
    usage() {
      return this.usedMemory / this.fullMemory;
    }
  }
};
</script>

<style scoped>
.usage-text {
  font-weight: bold;
}
</style>
